import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {smssignverifys, smssignApprove, smssignDisapprove} = api

/**
 * 查找列表
 */
export async function findSmssignverifys(params) {
    return request({url:smssignverifys, method: 'get', data: params,})
}
/**
 * 审核通过
 */
export async function approveSmssign(params) {
    return request({url:smssignApprove, method: 'post', data: params,})
}
/**
 * 审核拒绝
 */

export async function disapproveSmssign(params) {
    return request({url:smssignDisapprove, method: 'post', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/smssignVerify.js